import moment from 'moment';

const BASE_URL = `${process.env.REACT_APP_API_BOOKINGS_BASE_URL}/DiscountCode`

export const validateDiscountCode = async (token, request) => {
    request.bookingStart.toJSON = function () { return `${moment(this).format('YYYY-MM-DD')}T${moment(this).format('HH:mm:ss')}`; }
    request.bookingEnd.toJSON = function () { return `${moment(this).format('YYYY-MM-DD')}T${moment(this).format('HH:mm:ss')}`; }

    const response = await fetch(BASE_URL + '/validate', {
        method: 'POST',
        headers: {
            'content-type': 'application/json',
            'authorization': `Bearer ${token}`
        },
        body: JSON.stringify(request)
    })

    if (response.status === 200) {
        return response.json();
    }

    throw response;
}
